import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { HighGuideCompanySignals } from '../../../product/dto/product-signal/high-guide-company-signals';

/**
 * A teammate recorded a recommendation somewhere in the company.
 *
 * The payload is the same `HighGuideCompanySignals` shape as the full company-signal grab, carrying the one new
 * signal plus its author, so it folds into the pool through the same merge path rather than a bespoke one. The
 * author rides along because they may never have signalled before, which would otherwise leave the recommendation
 * unattributable until the next full grab.
 *
 * Never fired for the signed-in user's own signals, and never for favorite-only signals.
 */
export class WebSocketReceiveHighGuideCompanySignalCreated extends WebSocketReceiveMessage {
  override payload: HighGuideCompanySignals;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(HighGuideCompanySignals, this.payload);
  }
}
